import main from './main';
import ui from './ui';

const rootReducer = {
  main,
  ui
};

export default rootReducer;
